export const education = [
  {
    id: 1,
    period: "2022-2024",
    degree: "Master of Business Administration / Finance, Business Analytics",
    institution: "FAST NUCES, Islamabad, Pakistan",
  },
  {
    id: 2,
    period: "2014-2018",
    degree: "Bachelor of Science in Computer Science",
    institution: "FAST NUCES, Islamabad, Pakistan",
  },
];
